module.exports = __webpack_public_path__ + "static/media/blur-bg.5b56696d.png";